import * as React from 'react';
import VideoPlayer from '@alife/bc-video-player';
import { isNode } from '../../../utils/micro-utils';
import '@alife/bc-video-player/index.css';
import * as webp from '@alife/bc-webp';
import './video.scss';
interface OtherProps {
  onItemClick?: (event: React.MouseEvent<HTMLElement>) => void;
  className?: string;
  videoPosition: string;
  videoIndex: number;
  thumb?: boolean;
  isCurrent: boolean;
  thumbWidth?: number;
  thumbHeight?: number;
  videoWidth?: number;
  videoHeight?: number;
}

export default class Video extends React.Component<
  PcMainImage.VideoData & OtherProps,
  { player: any }
> {
  videoElement: HTMLElement;
  videoContainerRef: HTMLElement;

  constructor(props) {
    super(props);
    this.state = {
      player: null,
    };
  }

  componentDidMount() {
    if (this.props.thumb) return;
    let videoUrl = '';
    if (this.props.videoUrl && this.props.videoUrl.sd) {
      videoUrl = this.props.videoUrl.sd.videoUrl;
    } else if (this.props.videoUrl && this.props.videoUrl.ld) {
      videoUrl = this.props.videoUrl.ld.videoUrl;
    }

    const player = new VideoPlayer(
      {
        videoId: this.props.videoId,
        container: this.videoContainerRef,
        width: this.props.videoWidth || 350,
        height: this.props.videoHeight || 350,
        logOptions: {
          scene: 'boothImage',
        },
        videoElement: videoUrl ? this.videoElement : undefined,
      },
      {
        autoplay: false,
        // 自动播放时静音
        muted: true,
        preload: 'auto',
        poster: this.props.videoCoverUrl,
      },
    );
    this.setState({
      player,
    }, () => {
      // 手动执行主图视频play
      //setTimeout(() => {
        const videoEle = this.videoContainerRef.querySelector('.bc-video-player video') as any;
        videoEle && videoEle.play();
     //}, 1000);
    });
  }

  componentWillUnmount() {
    if (this.props.thumb) return;
    this.state.player &&
      this.state.player.destory &&
      this.state.player.destory();
  }

  handleVideoUrl(url) {
    const pos = url.indexOf('?');

    if (pos === -1) return url;

    return url.substring(0, pos);
  }

  render() {
    let videoUrl = '';
    const { thumb, videoCoverUrl } = this.props;
    if (this.props.videoUrl && this.props.videoUrl.sd) {
      videoUrl = this.props.videoUrl.sd.videoUrl;
    } else if (this.props.videoUrl && this.props.videoUrl.ld) {
      videoUrl = this.props.videoUrl.ld.videoUrl;
    }

    if (isNode() && !thumb) {
      return (
        <div className="detail-video-placeholder">
          <video
            poster={webp.use(this.props.videoCoverUrl)}
            preload="auto"
            className="video-preload-hidden"
            ref={dom => {
              this.videoElement = dom;
            }}
            src={this.handleVideoUrl(videoUrl)}
            style={{ display: 'none' }}
          ></video>
          <img
            src={
              videoCoverUrl
                ? webp.use(videoCoverUrl)
                : '//is.alibaba.com/images/eng/no_photo_w250h250.gif'
            }
            alt="image"
            className="detail-video-placeholder__cover"
          />
          <img
            src="https://img.alicdn.com/tfs/TB1NB4J2qL7gK0jSZFBXXXZZpXa-14-16.svg"
            alt="video-icon"
            className="detail-video-placeholder__video-icon"
          />
        </div>
      );
    }

    return (
      <div className="video-thumb">
        {!thumb && videoUrl && (
          <video
            poster={webp.use(this.props.videoCoverUrl)}
            preload="auto"
            className="video-preload-hidden"
            ref={dom => {
              this.videoElement = dom;
            }}
            src={this.handleVideoUrl(videoUrl)}
            style={{ display: 'none' }}
          ></video>
        )}
        {!thumb && (
          <div
            ref={dom => {
              this.videoContainerRef = dom;
            }}
          ></div>
        )}
        {!this.state.player && (
          <div className="video-place-holder" onClick={this.props.onItemClick}>
            <div
              className="thumb-shadow"
              style={{
                width: this.props.thumbWidth,
                height: this.props.thumbHeight,
              }}
            ></div>
            <img
              src="https://img.alicdn.com/tfs/TB1NB4J2qL7gK0jSZFBXXXZZpXa-14-16.svg"
              alt="video-icon"
              className="video-icon"
            />
            <img
              src={
                videoCoverUrl
                  ? webp.use(videoCoverUrl)
                  : '//is.alibaba.com/images/eng/no_photo_w250h250.gif'
              }
              alt="image"
              className="J-slider-cover-item"
              style={{
                width: this.props.thumbWidth,
                height: this.props.thumbHeight,
              }}
            />
          </div>
        )}
      </div>
    );
  }
}
